import { BreadcrumbItem } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { AuditBreadcrumbs } from '../../../components/breadcrumbs/AuditBreadcrumbs';
import {
  createdReportsBreadcrumbItem,
  globalReportsBreadcrumbItem,
} from '../../../components/breadcrumbs/breadcrumb-items';

export interface GlobalReportsBreadcrumbsProps {
  items?: readonly BreadcrumbItem[];
  showCreatedReports?: boolean;
  showGlobalReports?: boolean;
}

export function GlobalReportsBreadcrumbs({
  items = [],
  showCreatedReports = false,
  showGlobalReports = false,
}: GlobalReportsBreadcrumbsProps) {
  const { formatMessage } = useIntl();

  const baseItems: BreadcrumbItem[] = [
    ...(showGlobalReports ? [globalReportsBreadcrumbItem(formatMessage)] : []),
    ...(showCreatedReports ? [createdReportsBreadcrumbItem(formatMessage)] : []),
    ...items,
  ];

  return <AuditBreadcrumbs items={baseItems} />;
}
